import { Observable } from "rxjs";
import { forkJoin } from "rxjs";
import { take } from "rxjs/operators";
import { BulkAction, ModalService, DataService } from "@bb-vendure/admin-ui/core";
import { DeleteDefaultProductDescriptionDocument, DeleteDefaultProductDescriptionMutation } from "src/generated-gql/graphql";

const deleteBulkAction: BulkAction = {
  location: "default-product-description-list",
  label: "Delete Selected Notices",
  icon: "trash",
  iconClass: "is-danger",
  onClick: ({ injector, selection, hostComponent, clearSelection }) => {
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);
    modalService
      .dialog({
        title: "Delete Selected Default product informations",
        body: `Are you sure you want to delete ${selection.length} notice${selection.length > 1 ? "s" : ""}?`,
        buttons: [
          { type: "secondary", label: "Cancel" },
          { type: "primary", label: "Delete", returnValue: selection },
        ],
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          const deleteObservables: Observable<DeleteDefaultProductDescriptionMutation>[] = [];
          for (const i in result) {
            deleteObservables.push(
              dataService.mutate(DeleteDefaultProductDescriptionDocument, {
                id: result[i].id,
              })
            );
          }
          forkJoin(deleteObservables).subscribe(() => {
            hostComponent.refresh();
            clearSelection();
          });
        }
      });
  },
};

export { deleteBulkAction };
